﻿import React, { createElement, useContext } from 'react';
import ReactDOM from 'react-dom';

import { DateSelection } from './form-date'
import moment from 'moment';
import { products } from '../../../Components/Pages/BookingFlowPage/Scripts/Endpoints';
import controller from './controller';
import "./fileupload";

document.addEventListener('DOMContentLoaded', () => {
  Array.prototype.slice.call(document.querySelectorAll('form .Form__MainBody')).forEach(formBodyElement => {

    //Replace submit button with a button that fetches new anti forgery token valid for the epi identity instead of aimo identity.
    //Since the forms are posted to a epi identity url it will fail if the anti forgery token is for a aimo identity(if the user is logged in with either epi or aimo)
    const submitButton = formBodyElement.querySelector('button[name="submit"]');
    const tempButton = document.createElement('button');
    tempButton.textContent = submitButton.textContent;
    tempButton.classList.add('FormSubmitButton');
    tempButton.classList.add('Temp__Button');
    submitButton.style.display = 'none';
    submitButton.insertAdjacentElement('afterend', tempButton);


    // Hide the tempButton if the element has the data-f-form-dbreadonly attribute or Form__Readonly__Message class
    if (document.querySelector('[data-f-form-dbreadonly]') || document.querySelector('.Form__Readonly__Message')) {
        tempButton.style.display = 'none';
    }

    function updateTokenAndSubmit(e) {
      e.preventDefault();
      const url = "/AntiForgery/GetToken/";
      e.target.classList.add('btn-disabled');

      fetch(url)
        .then(function (response) {
          switch (response.status) {
            case 200:
              return response.text();
            case 404:
              throw response;
          }
        })
        .then(function (template) {
          const htmlDiv = document.createElement('div');
          htmlDiv.innerHTML = template;
          const token = htmlDiv.querySelector('input[name="__RequestVerificationToken"]').value;
          document.querySelector('input[name="__RequestVerificationToken"]').value = token;
          formBodyElement.querySelector('button[name="submit"]').click();
          e.target.classList.remove('btn-disabled');
        })
        .catch(function (response) {
          console.log(response.statusText);
          e.target.classList.remove('btn-disabled');
        });
    }
    function keyHandler(e) {
      if (e.key === 'Enter' && e.target.tagName !== 'TEXTAREA') {
        e.preventDefault();
        updateTokenAndSubmit(e);
      }
    }

    tempButton.addEventListener('click', updateTokenAndSubmit);
    formBodyElement.addEventListener('keydown', keyHandler);

    var selectCount = 0;
    var fileUploadCount = 0;

    Array.prototype.slice.call(formBodyElement.querySelectorAll('form .Form__MainBody .FormStep')).forEach(formStepElement => {
      //Radiobuttons and Checkboxes
      const selectButtonListItems = Array.prototype.slice.call(formStepElement.querySelectorAll('form .Form__Element.FormChoice fieldset label'));
      if (selectButtonListItems.length > 0) {
        selectButtonListItems.forEach(listItem => {
          listItem.appendChild(document.createElement('SPAN'));
        })
      }

      //Textarea
      const textareaItems = Array.prototype.slice.call(formStepElement.querySelectorAll('textarea'));
      const urlParams = new URLSearchParams(window.location.search);
      const pmcName = urlParams.get('p');
      if (textareaItems.length > 0 && pmcName) textareaItems[0].value=pmcName;

      //Dropdownlist
      const selectContainerItems = Array.prototype.slice.call(formStepElement.querySelectorAll('form .Form__Element.FormSelection select'));
      if (selectContainerItems.length > 0) {
        selectContainerItems.forEach(selectItem => {
          selectItem.setAttribute('data-controller', 'accessible-select');
          selectCount++;
        })
      }

      //File upload
      const fileuploadContainerItems = Array.prototype.slice.call(formStepElement.querySelectorAll('form .Form__Element.FormFileUpload'));
      if (fileuploadContainerItems.length > 0) {
        fileuploadContainerItems.forEach(fileupload => {
          fileupload.setAttribute('data-controller', 'accessible-fileupload');
          fileUploadCount++;
        })
      }

      //Buttons
      const buttonItems = Array.prototype.slice.call(formStepElement.querySelectorAll('form .Form__MainBody button, form .Form__MainBody input[type="reset"], form .Form__NavigationBar .btnNext, form .Form__NavigationBar .btnPrev'));
      const stepItems = Array.prototype.slice.call(formBodyElement.querySelectorAll('form .Form__NavigationBar .btnNext, form .Form__NavigationBar .btnPrev'));
      const stepItemsMoved = Array.prototype.slice.call(formStepElement.querySelectorAll('form .Form__ButtonWrapper .btnNext, form .Form__ButtonWrapper .btnPrev'));

      const newButtonWrapper = document.createElement('DIV');
      newButtonWrapper.classList.add('Form__ButtonWrapper');

      if (stepItems.length > 0) {
        if(!formStepElement.classList.contains('hide'))
          stepItems.forEach(stepItem => newButtonWrapper.appendChild(stepItem))
      }

      if (stepItemsMoved.length > 0) {
        if(!formStepElement.classList.contains('hide'))
          stepItemsMoved.forEach(stepItem => newButtonWrapper.appendChild(stepItem))
      }

      if (buttonItems.length > 0) {
        buttonItems.forEach(buttonItem => { 
          if(buttonItem.title) {
            const previousElement = buttonItem.previousElementSibling;
            const nextElement = buttonItem.nextElementSibling;

            const newSingleButtonWrapper = document.createElement('DIV');
            newSingleButtonWrapper.classList.add('Form__SingleButtonWrapper');
            newSingleButtonWrapper.appendChild(buttonItem);

            if(previousElement) {
              insertAfter(newSingleButtonWrapper, previousElement)
              //previousElement.after(newSingleButtonWrapper);
						} else {
              nextElement.insertBefore(newSingleButtonWrapper);
						}
          }
          else {
            newButtonWrapper.appendChild(buttonItem);
          }
        })
      }

      formStepElement.appendChild(newButtonWrapper);

      //Datepicker
      const addDatepicker = (singleDatepickerWrapper) => {
        const existingPicker = singleDatepickerWrapper.querySelector('.Form__CustomInput[class*="FormDateTime"]') || singleDatepickerWrapper;
        existingPicker.classList.add('hide');
        const validationErrorSpans = singleDatepickerWrapper.parentNode.querySelectorAll('.Form__Element__ValidationError');
        const validationErrorSpansArray = validationErrorSpans ? Array.prototype.slice.call(validationErrorSpans) : [];
        validationErrorSpansArray.forEach(span => span.removeAttribute('style'));
        const scriptTag = singleDatepickerWrapper.querySelector('SCRIPT') || singleDatepickerWrapper.parentNode.querySelector('SCRIPT');
        if (scriptTag && scriptTag.innerText.includes('timepicker')) {
          const visibleInput = document.createElement('INPUT');
          visibleInput.classList.add('FormTextbox__Input');
          visibleInput.setAttribute("type", "time");
          existingPicker.after(visibleInput);
          visibleInput.addEventListener('change', (e) => {
            existingPicker.value = e.target.value.toLowerCase().includes('m') ? e.target.value : moment(e.target.value, ["HH.mm"]).format("hh:mm A");
          })
        } else {
          const appContainer = document.createElement('DIV');
          appContainer.classList.add('Form__DatePickerWrapper');
          insertAfter(appContainer, existingPicker);

          //const currentLanguage = document.querySelector('html').getAttribute('lang');
          const currentCountry = document.querySelector('html').getAttribute('country');
          const tooltip = existingPicker.getAttribute('title') ?? '';
          ReactDOM.render(<DateSelection existingPicker={existingPicker} locale={currentCountry} title={tooltip} showAllDates={true} />, appContainer);
        }
      }

      const datepickerWrappers = Array.prototype.slice.call(formStepElement.querySelectorAll('form .Form__CustomElement.FormDateTime'));
      const datepickerRangeFieldsets = Array.prototype.slice.call(formStepElement.querySelectorAll('form .Form__CustomElement.FormDateTimeRange'));
      if (datepickerWrappers.length > 0) {
        datepickerWrappers.forEach(singleDatepickerWrapper => {
          addDatepicker(singleDatepickerWrapper);
        })
      }
      if (datepickerRangeFieldsets.length > 0) {
        datepickerRangeFieldsets.forEach(singleDatepickerFieldset => {
          const datetimeRangeInputs = Array.prototype.slice.call(singleDatepickerFieldset.querySelectorAll('input'));
          datetimeRangeInputs.forEach(input => {
            addDatepicker(input);
          })
        })
      }
    })

    if (selectCount > 0 || fileUploadCount > 0)
      controller.parse(formBodyElement);

  })

  //document.addEventListener("click", closeAllSelect);
});

const initCustomDropDownLists = function(wrapper, selElmnt) {
  /* For each element, create a new DIV that will act as the selected item: */
  const selectedItem = document.createElement('DIV');
  selectedItem.classList.add('Form__FormSelectWrapper__Selector');
  selectedItem.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
  wrapper.appendChild(selectedItem);

  /* For each element, create a new DIV that will contain the option list: */
  const selectItems = document.createElement("DIV");
  selectItems.classList.add('Form__FormSelectWrapper__SelectItems');
  selectItems.classList.add('Form__FormSelectWrapper__SelectItems--hide');

  for (var j = 1; j < selElmnt.length; j++) {
    const singleSelectItem = document.createElement("DIV");
    singleSelectItem.innerHTML = selElmnt.options[j].innerHTML;

    singleSelectItem.addEventListener("click", function(e) {
        /* When an item is clicked, update the original select box,
        and the selected item: */
        var s = this.parentNode.parentNode.getElementsByTagName("select")[0];
        var h = this.parentNode.previousSibling;

        for (var i = 0; i < s.length; i++) {
          if (s.options[i].innerHTML === this.innerHTML) {
            s.selectedIndex = i;
            h.innerHTML = this.innerHTML;
            var y = this.parentNode.getElementsByClassName("same-as-selected");
            for (var k = 0; k < y.length; k++) {
              y[k].removeAttribute("class");
            }
            this.setAttribute("class", "same-as-selected");
            break;
          }
        }
        h.click();
    });

    selectItems.appendChild(singleSelectItem);
  }

  wrapper.appendChild(selectItems);

  selectedItem.addEventListener("click", function(e) {
    /* When the select box is clicked, close any other select boxes,
    and open/close the current select box: */
    e.stopPropagation();
    closeAllSelect(this);
    this.nextSibling.classList.toggle("Form__FormSelectWrapper__SelectItems--hide");
    this.classList.toggle("Form__FormSelectWrapper__Selector--active");
  });
  //}
}

const closeAllSelect = function(elmnt) {
  /* A function that will close all select boxes in the document,
  except the current select box: */
  var x, y, i, arrNo = [];
  x = document.getElementsByClassName("Form__FormSelectWrapper__SelectItems");
  y = document.getElementsByClassName("Form__FormSelectWrapper__Selector");
  for (i = 0; i < y.length; i++) {
    if (elmnt === y[i]) {
      arrNo.push(i)
    } else {
      y[i].classList.remove("Form__FormSelectWrapper__Selector--active");
    }
  }
  for (i = 0; i < x.length; i++) {
    if (arrNo.indexOf(i)) {
      x[i].classList.add("Form__FormSelectWrapper__SelectItems--hide");
    }
  }
}

const insertAfter = function(newNode, referenceNode) {
  referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
}
